import React from "react";
import { Card, CardContent } from "../../../ui/card";
import { Button } from "../../../ui/button";

/**
 * Empty-state placeholder for tables / lists.
 *
 * Props:
 *  - icon: ReactNode (lucide icon)
 *  - title: string
 *  - description: string
 *  - action: { label, onClick } — optional CTA
 */
const EmptyState = ({ icon, title, description, action }) => (
  <Card>
    <CardContent className="flex flex-col items-center justify-center gap-3 py-12 text-center">
      {icon && <div className="text-muted-foreground">{icon}</div>}
      <h3 className="text-lg font-semibold">{title}</h3>
      {description && (
        <p className="max-w-md text-sm text-muted-foreground">{description}</p>
      )}
      {action && (
        <Button onClick={action.onClick} className="mt-2">
          {action.label}
        </Button>
      )}
    </CardContent>
  </Card>
);

export default EmptyState;
